import { Component } from '@angular/core';
import { UserNavigationItem } from '@/app/platform/platform-core/user/models/user-navigation-item';
import { PlatformAppContext } from '@/app/platform/platform-context/platform-app-context';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
    selector: 'egi-breadcrumb',
    templateUrl: './egi-breadcrumb.component.html',
    styleUrls: ['./egi-breadcrumb.component.scss'],
    standalone: false
})
export class EgiBreadcrumbComponent {
  constructor(readonly appContext: PlatformAppContext, private readonly router: Router) {}

  readonly breadcrumbItems$: Observable<UserNavigationItem[]> = combineLatest([
    this.appContext.activeApp$,
    this.appContext.activeNavigationItem$
  ]).pipe(
    map(([activeApp, activeNavigationItem]) => {
      if (!activeApp) {
        return [];
      }
      if (!activeNavigationItem || activeNavigationItem.appId !== activeApp.id) {
        return [activeApp.rootNavigationItem];
      }
      return [
        ...activeNavigationItem.findAncestors(activeApp.rootNavigationItem).reverse(),
        activeNavigationItem
      ];
    })
  );

  get externalUrl(): string {
    return this.appContext?.activeNavigationItem?.config?.url
  }

  isExternalPage(): boolean {
    return this.appContext?.activeNavigationItem?.isExternalPage;
  }

  readonly latestBreadcrumbItem$ = this.breadcrumbItems$.pipe(
    map(items => {
      return items[items.length - 1];
    })
  );

  routeToNavigationItem(item: UserNavigationItem, isLatest: boolean) {
    if (item.isMenu || isLatest) {
      return;
    }
    this.router.navigate([item.clone().routerLink], {
      queryParams: {
        navId: item.id
      }
    });
  }

  refreshComponent(item: UserNavigationItem) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([item.clone().routerLink], {
        queryParams: {
          navId: item.id
        },
      })
    )
  }
}
